// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyDjUHWJYEgasCl-nfrag_dXfYxKlBR5E5E",
    authDomain: "hackathon-online.firebaseapp.com",
    databaseURL: "https://hackathon-online.firebaseio.com",
    projectId: "hackathon-online",
    storageBucket: "hackathon-online.appspot.com",
    messagingSenderId: "132588339420",
    appId: "1:132588339420:web:45eafda3d7192b050b7419",
    measurementId: "G-DTEDVTQFV9"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
